import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function contactListUpdateRequiredReducer(state = initialState.contactListUpdateRequired, action) {
    switch (action.type) {
        case types.LOAD_CONTACTS_SUCCESS:
        case types.LOAD_CONTACTS_UPDATE_SUCCESS:
            return false;
        case types.UPDATED_CONTACT_INCOMING:
           case types.UPDATED_CONTACT_SUCCESS:
            return true;
        default:
            return state;
    }
}

